'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var common = require('arm-common');
var PropTypes = require('prop-types');
var update = require('immutability-helper');
var armRouter = require('arm-router');
var controls = require('arm-gui/dist/controls');
var agui = require('arm-gui');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var common__default = /*#__PURE__*/_interopDefaultLegacy(common);
var update__default = /*#__PURE__*/_interopDefaultLegacy(update);

var ApplicationContainer = function ApplicationContainer(props) {
  console.log('[ApplicationContainer.jsx]: render');
  var children = props.children,
      id = props.id,
      className = props.className;
  var idDiv = common__default['default'].Utils.uuid('ApplicationContainer');

  if (id) {
    idDiv = props.id;
  }

  var clsName = ' arm-core-layouts-applicationcontainer ';

  if (className) {
    clsName += className;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: clsName,
    id: idDiv
  }, children);
};

ApplicationContainer.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string
};

var Body = function Body(props) {
  console.log('[ApplicationContainer.jsx]: render');
  var children = props.children,
      id = props.id,
      className = props.className;
  var idDiv = common__default['default'].Utils.uuid('arm-core-layouts-applicationcontainer-body');

  if (id) {
    idDiv = props.id;
  }

  var clsName = ' arm-core-layouts-applicationcontainer-body ';

  if (className) {
    clsName += className;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: idDiv,
    className: clsName
  }, children);
};

Body.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string
};
ApplicationContainer.Body = Body;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var errChildren = function errChildren() {
  console.warn("[CollapseContent.jsx]: the children of component must be two.");
  return /*#__PURE__*/React.createElement("div", null, " add two children to component ", /*#__PURE__*/React.createElement("pre", null, "CollapseContent"), " ");
}; //TODO: aggiungere funzionalità pinnable (come in outlook)


var CollapseContent = function CollapseContent(props) {
  console.log("[CollapseContent.jsx]: render");
  var id = props.id,
      width = props.width,
      nextElemWidth = props.nextElemWidth,
      children = props.children;
  if (children && React.Children.count(children) !== 2) errChildren();

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      collapse = _React$useState2[0],
      handleCollapse = _React$useState2[1];

  var styleMenu = {
    height: nextElemWidth || "calc( 100vh - ".concat("70px", ")")
  };
  var styleContentItems = {
    width: "calc( 100% - ".concat("107px", ")")
  };

  if (collapse) {
    styleContentItems = {
      width: '100%'
    };
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "arm-core-layouts-collapse-content-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "arm-core-layouts-collapse-content-menu",
    style: styleMenu
  }, children[0]), /*#__PURE__*/React.createElement("div", {
    className: "arm-core-layouts-collapse-content-items",
    style: styleContentItems
  }, children[1]));
};

CollapseContent.propTypes = {
  id: PropTypes.string,
  width: PropTypes.string.isRequired,
  nextElemWidth: PropTypes.string,
  children: PropTypes.node
};

var MenuLeft = function MenuLeft(props) {
  console.log("[MenuLeft]: render");
  var className = props.className,
      widthOpen = props.widthOpen,
      widthClose = props.widthClose,
      children = props.children;
  var initialState = {
    menu: {
      open: true,
      width: widthOpen || '100px',
      widthOpen: widthOpen || '100px',
      widthClose: widthClose || '50px'
    }
  };

  var _React$useState = React.useState(initialState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setstate = _React$useState2[1];

  var idIconDiv = common__default['default'].Utils.uuid('arm-core-layouts-menu-icon-container');
  var clsName = ' arm-core-layouts-menu-left ';

  if (className) {
    clsName += className;
  }

  var onclickIcon = function onclickIcon() {
    var menuOpen = !state.menu.open;
    var width = state.menu.widthOpen;

    if (!menuOpen) {
      width = state.menu.widthClose;
    }

    var newState = update__default['default'](state, {
      menu: {
        open: {
          $set: menuOpen
        },
        width: {
          $set: width
        }
      }
    });
    setstate(newState);
  };

  return /*#__PURE__*/React.createElement(VBox, {
    style: {
      width: state.menu.width,
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(armRouter.Menu, {
    className: clsName,
    vertical: true,
    width: state.menu.width,
    height: "calc(100% - 70px)"
  }, children && React.Children.map(children, function (child) {
    if (child && child.type && child.type.toString() === Item.toString()) {
      return /*#__PURE__*/React.cloneElement(child, _objectSpread2(_objectSpread2({}, child.props), {}, {
        openMenu: state.menu.open
      }));
    } else {
      return child;
    }
  }), /*#__PURE__*/React.createElement("div", {
    id: idIconDiv,
    className: "arm-core-layouts-menu-icon-container",
    onClick: onclickIcon
  }, state.menu.open ? /*#__PURE__*/React.createElement("i", {
    className: "arm-core-layouts-menu-icon fas fa-caret-square-left fa-2x"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "arm-core-layouts-menu-icon fas fa-caret-square-right fa-2x"
  }))));
};

MenuLeft.propTypes = {
  className: PropTypes.string,
  widthOpen: PropTypes.string,
  widthClose: PropTypes.string,
  children: PropTypes.node
};

var Item = function Item(props) {
  console.log("[MenuLeftLabel]: render");
  var className = props.className,
      icon = props.icon,
      title = props.title,
      children = props.children,
      to = props.to,
      openMenu = props.openMenu;
  var menuLinkClass = ' arm-core-layouts-menu-link ';

  if (className) {
    menuLinkClass += className;
  }

  var iconCls = ' arm-core-layouts-menu-left-item-icon ';

  if (icon) {
    iconCls += icon;
  }

  return /*#__PURE__*/React.createElement(armRouter.MenuLink, {
    activeClassName: menuLinkClass,
    className: menuLinkClass,
    to: to
  }, /*#__PURE__*/React.createElement("div", {
    className: "arm-core-layouts-menu-left-item"
  }, /*#__PURE__*/React.createElement("i", {
    className: iconCls
  }), /*#__PURE__*/React.createElement("div", {
    className: "arm-core-layouts-menu-left-title"
  }, openMenu ? title || children : null)));
};

Item.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
MenuLeft.Item = Item;

/**
 * @example
 * ```jsx
 * const menuItems = [
 *      {
 *          label: utente.firstname,
 *          className: 'hoverless separator' //hoverless: unclickable, separator: to add a line to separate group of elements
 *      },
 *      {
 *          label: i18n('USER_INFO.SETTINGS', 'Impostazioni'),
 *          link: '#/settings',
 *          icon: 'fas fa-cog',
 *          className: 'separator'
 *      },
 *      {
 *          label: i18n('USER_INFO.LOG_OUT', 'Disconnettiti'),
 *          onClick: () => logoutOnClick && logoutOnClick().then(() => history.replace('logout'))
 *      }      
 * ];
 * <UserInfo 
 *      menuItems={menuItems}
 *      userName={utente.firstname}
 * />
 * ```
 */

var UserInfo = function UserInfo(_ref) {
  var menuItems = _ref.menuItems,
      userName = _ref.userName;
  console.log('[UserInfo.jsx]: render');
  return /*#__PURE__*/React.createElement(controls.PopupMenu, {
    popupIcon: "none",
    className: "user-info",
    pos: "down-right",
    label: userName === null || userName === void 0 ? void 0 : userName.charAt(0).toUpperCase(),
    def: menuItems
  });
};

UserInfo.propTypes = {
  /** Array for def prop of agui.PopupMenu */
  menuItems: PropTypes.array,
  userName: PropTypes.string
};

var NavBarElemRight = function NavBarElemRight(props) {
  console.log("[NavBarElemRight.jsx]: render");
  var id = props.id,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    style: {
      marginLeft: "auto"
    },
    className: className ? "arm-nav-bar-right " + className : "arm-nav-bar-right"
  }, children);
};

var NavBarElem = function NavBarElem(props) {
  console.log("[NavBarElem.jsx]: render");
  var id = props.id,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: className ? "arm-nav-bar-elem " + className : "arm-nav-bar-elem"
  }, children);
};

var NavBar = function NavBar(props) {
  console.log("[NavBar.jsx]: render");
  var id = props.id,
      className = props.className,
      children = props.children;
  return /*#__PURE__*/React.createElement("nav", {
    id: id,
    className: className ? "arm-nav-bar " + className : "arm-nav-bar"
  }, children);
};
/**
 * Main navigation bar
 * @example
 * ```jsx
 * const userMenu = [
 *      {
 *          label: utente.firstname,
 *          className: 'hoverless separator' //hoverless: unclickable, separator: to add a line to separate group of elements
 *      },
 *      {
 *          label: i18n('USER_INFO.SETTINGS', 'Impostazioni'),
 *          link: '#/settings',
 *          icon: 'fas fa-cog',
 *          className: 'separator'
 *      },
 *      {
 *          label: i18n('USER_INFO.LOG_OUT', 'Disconnettiti'),
 *          onClick: () => logoutOnClick && logoutOnClick().then(() => history.replace('logout'))
 *      }      
 * ];
 * <TopBar homePath="home" logo="./images/fideuram_logo.png" userMenu={userMenu} userName={utente.firstname}>
 *      <MenuLink to="/brand"> Brand </MenuLink>
 *      <MenuLink to="/contacts"> Contacts </MenuLink>
 * </TopBar>
 * ```
 */


var TopBar = function TopBar(_ref) {
  var homePath = _ref.homePath,
      logo = _ref.logo,
      userMenu = _ref.userMenu,
      userName = _ref.userName,
      children = _ref.children;
  console.log("[TopBar.jsx]: render");
  return /*#__PURE__*/React.createElement(NavBar, {
    className: "top-bar"
  }, /*#__PURE__*/React.createElement(NavBarElem, {
    className: "logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#/".concat(homePath || 'home')
  }, /*#__PURE__*/React.createElement("img", {
    src: logo || "./images/arm_icona.svg"
  }))), /*#__PURE__*/React.createElement(NavBarElem, null, /*#__PURE__*/React.createElement(armRouter.Menu, null, children)), /*#__PURE__*/React.createElement(NavBarElemRight, null, /*#__PURE__*/React.createElement(UserInfo, {
    menuItems: userMenu,
    userName: userName
  })));
};

TopBar.propTypes = {
  /** Alternative path of default: 'home' */
  homePath: PropTypes.string,

  /** Logo path */
  logo: PropTypes.string,

  /** Items of user menu */
  userMenu: PropTypes.array,
  userName: PropTypes.string,

  /** MenuLink or MenuDrop components */
  children: PropTypes.node
};

var MasterPageContainer = function MasterPageContainer(props) {
  console.log('[MasterPageContainer.jsx]: render');
  var className = props.className,
      style = props.style,
      children = props.children;
  var inlineStyle = {};

  if (style) {
    inlineStyle = style;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "arm-core-layouts-masterpagecontainer ".concat(className || ""),
    style: inlineStyle
  }, children);
};

MasterPageContainer.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

function addHash(url) {
  var fChar = url.charAt(0);
  if (fChar === "#") return url;
  if (fChar === "/") return "#".concat(url);
  return "#/".concat(url);
}

var BreadCrumbs = function BreadCrumbs(_ref) {
  var elems = _ref.elems;
  return /*#__PURE__*/React.createElement("div", {
    className: "breadcrumbs"
  }, elems.map(function (elem, index) {
    return elems.length !== index + 1 ? /*#__PURE__*/React.createElement(React.Fragment, {
      key: "breadcrumb-el-".concat(index)
    }, /*#__PURE__*/React.createElement("a", {
      href: addHash(elem.url)
    }, elem.label), /*#__PURE__*/React.createElement("i", {
      className: "fas fa-circle"
    })) : /*#__PURE__*/React.createElement("span", {
      key: "breadcrumb-el-".concat(index)
    }, elem.label);
  }));
};

var PageHeaderContainer = function PageHeaderContainer(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "page-header-container"
  }, children);
};

var PageHeader = function PageHeader(props) {
  console.log("[PageHeader.jsx]: render");
  var className = props.className,
      title = props.title,
      breadcrumbs = props.breadcrumbs,
      backurl = props.backurl,
      children = props.children;
  var withLink = breadcrumbs || backurl ? " with-link " : " ";
  return /*#__PURE__*/React.createElement("div", {
    className: "page-header".concat(withLink).concat(className ? className : "")
  }, backurl && /*#__PURE__*/React.createElement("a", {
    className: "backurl",
    href: addHash(backurl)
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-left"
  }), " ", common.i18n("B_T.PAGE_HEADER.BACK", "Indietro")), /*#__PURE__*/React.createElement("div", {
    className: "page-header-content"
  }, title && /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, title), breadcrumbs && /*#__PURE__*/React.createElement(BreadCrumbs, {
    elems: breadcrumbs
  }), children && /*#__PURE__*/React.createElement("div", {
    className: "elements"
  }, children)));
};

PageHeader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  breadcrumbs: PropTypes.arrayOf(PropTypes.object),
  backurl: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
};
PageHeaderContainer.PageHeader = PageHeader;

var PageBody = function PageBody(props) {
  console.log('[PageBody.jsx]: render');
  var className = props.className,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "page-body ".concat(className || "")
  }, children);
};

PageBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

var PageContainer = function PageContainer(props) {
  console.log('[PageContainer.jsx]: render');
  var children = props.children,
      id = props.id,
      className = props.className,
      style = props.style;
  var idDiv = common__default['default'].Utils.uuid('PageContainer');

  if (id) {
    idDiv = props.id;
  }

  var clsName = ' arm-core-layouts-page-container ';

  if (className) {
    clsName += className;
  }

  var innerStyle = {};

  if (style) {
    innerStyle = style;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: clsName,
    id: idDiv,
    style: innerStyle
  }, children);
};

PageContainer.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

var PageFilter = function PageFilter(props) {
  console.log('[PageFilter.jsx]: render');
  var className = props.className;
  return /*#__PURE__*/React.createElement(controls.LineBar, _extends({
    className: "page-filter ".concat(className || "")
  }, props));
};

PageFilter.propTypes = {
  className: PropTypes.string
};

var PageFilterGroup = function PageFilterGroup(props) {
  console.log('[PageFilterGroup.jsx]: render');
  return /*#__PURE__*/React.createElement(controls.LineBarGroup, props);
};

var PageFooter = function PageFooter(props) {
  console.log('[PageFooter.jsx]: render');
  var className = props.className;
  return /*#__PURE__*/React.createElement(controls.LineBar, _extends({
    className: "page-footer ".concat(className || "")
  }, props));
};

PageFooter.propTypes = {
  className: PropTypes.string
};

var PageFooterGroup = function PageFooterGroup(props) {
  console.log('[PageFooterGroup.jsx]: render');
  return /*#__PURE__*/React.createElement(controls.LineBarGroup, props);
};

var SidePopupId = 1;

var SidePopup = function SidePopup(props) {
  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      reduced = _React$useState2[0],
      setReduced = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      doRender = _React$useState4[0],
      setDoRender = _React$useState4[1];

  var _React$useState5 = React.useState("arm_asidepopup_" + SidePopupId++),
      _React$useState6 = _slicedToArray(_React$useState5, 1),
      baseId = _React$useState6[0];

  var headId = baseId + "_header";
  var popupId = baseId + "_popup";
  var title = props.title || "";
  var side = props.side || "right";
  var loading = props.loading || false;
  var loadingMessage = props.loadingMessage || "Caricamento in corso";
  var visible = props.visible;
  var onClose = props.onClose;
  var children = /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
  var useReducer = props.useReducer || false;
  var reduceIcoBase = "fa fa-caret";
  var reduceIcoNormal = side === "right" ? reduceIcoBase + "-right" : reduceIcoBase + "-left";
  var reduceIcoReduced = side === "right" ? reduceIcoBase + "-left" : reduceIcoBase + "-right";
  var reduceIco = reduced ? reduceIcoReduced : reduceIcoNormal;
  var sizeClz = " size-" + (props.size || "NORMAL").toLowerCase() + " ";
  var modalClz = props.noModal ? "" : " modal ";
  var topClz = props.top ? " top " : "";
  var reduceClz = (useReducer ? ' reduce-support ' : '') + (useReducer && reduced ? ' reduced ' : '');
  var clzName = (props.className || '') + sizeClz + modalClz + topClz + reduceClz;

  var reduceClick = function reduceClick(e) {
    e.preventDefault();

    if (useReducer) {
      setReduced(!reduced);
      var md = jQuery("#" + popupId + " .modal-dialog");

      if (!reduced) {
        var w = md.width(); // .style.width.replace("px", ""));

        md.attr("style", "left: " + (-w + 40) + "px");
      } else {
        md.removeAttr("style");
      }
    }
  }; // show/hide diretto:
  // const doRender  = visible;


  if (visible) {
    if (!doRender) {
      setDoRender(true);
      var tryget = setInterval(function () {
        console.log("popup finding...");
        var sp = document.getElementById(popupId);

        if (sp) {
          console.log("popup found!");
          sp.className += " in ";
          clearInterval(tryget);
        }
      }, 140);
    } else {
      if (clzName.indexOf(" in ") < 0) clzName += " in ";
    }
  } else {
    if (doRender) {
      var sp = document.getElementById(popupId);

      if (sp) {
        var clz = sp.className;
        clz = clz.replace(/ in /g, " ");
        sp.className = clz;
        setTimeout(function () {
          setDoRender(false);
        }, 300);
      }
    }
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, doRender && /*#__PURE__*/React.createElement("div", {
    id: popupId,
    className: ' SidePopup ' + clzName + // (loading ? ' loading' : '') + 
    ' show ' + side + ' fade ',
    tabIndex: "-1",
    role: "dialog",
    "aria-labelledby": headId,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: "modal-dialog",
    role: "document"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-content"
  }, onClose && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close close",
    "data-dismiss": "modal",
    "aria-label": "Chiudi",
    onClick: onClose
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), useReducer && /*#__PURE__*/React.createElement("button", {
    className: "btn-reducer btn btn-default",
    title: "riduci",
    onClick: reduceClick
  }, /*#__PURE__*/React.createElement("i", {
    className: reduceIco
  })), loading && /*#__PURE__*/React.createElement("div", {
    className: "modal-loading-hover"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ring"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lds-ring"
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement("div", {
    className: "loading-message"
  }, loadingMessage)), children), " ")));
};

var ModalHeader = function ModalHeader(_ref) {
  var title = _ref.title,
      className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-header ".concat(className || "")
  }, title && /*#__PURE__*/React.createElement("h4", {
    className: "modal-title"
  }, title), /*#__PURE__*/React.createElement("div", null, children));
};

ModalHeader.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
};

var ModalBody = function ModalBody(_ref2) {
  var className = _ref2.className,
      children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-body ".concat(className || "")
  }, " ", children, " ");
};

ModalBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
};

var ModalFooter = function ModalFooter(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-footer ".concat(className || "")
  }, " ", children, " ");
};

ModalFooter.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
};
SidePopup.propTypes = {
  side: PropTypes.string,
  visible: PropTypes.bool,
  size: PropTypes.oneOf(["NORMAL", "SMALL", "LARGE"]),
  useReducer: PropTypes.bool,
  noModal: PropTypes.bool,
  top: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  onClose: PropTypes.func
};
SidePopup.header = ModalHeader;
SidePopup.body = ModalBody;
SidePopup.footer = ModalFooter;

var VBox = function VBox(props) {
  console.log('[VBox.jsx]: render');
  var id = props.id,
      className = props.className,
      style = props.style,
      children = props.children;
  var idDiv = common__default['default'].Utils.uuid('VBox');

  if (id) {
    idDiv = props.id;
  }

  var clsName = ' arm-core-layouts-VBox ';

  if (className) {
    clsName += className;
  }

  var inlineStyle = {};

  if (style) {
    inlineStyle = style;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: idDiv,
    className: clsName,
    style: inlineStyle
  }, children);
};

VBox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

var HBox = function HBox(props) {
  console.log('[HBox.jsx]: render');
  var id = props.id,
      className = props.className,
      style = props.style,
      children = props.children;
  var idDiv = common__default['default'].Utils.uuid('HBox');

  if (id) {
    idDiv = props.id;
  }

  var clsName = ' arm-core-layouts-HBox ';

  if (className) {
    clsName += className;
  }

  var inlineStyle = {};

  if (style) {
    inlineStyle = style;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: idDiv,
    className: clsName,
    style: inlineStyle
  }, children);
};

HBox.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node
};

var name = "arm-core-layouts";
var version = "0.1.13";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var license = "Armundia";
var main = "./dist/main/index.js";
var files = [
	"dist"
];
var devDependencies = {
	"arm-gulp-builders": "^1.1.2",
	"arm-themes": "^1.1.1",
	"babel-eslint": "^10.0.3",
	"eslint-plugin-import": "2.22.0",
	"eslint-plugin-react": "7.20.3",
	"immutability-helper": "^3.1.1",
	react: "^16.13.1",
	"react-dom": "16.13.1",
	"react-redux": "^7.2.0",
	redux: "^4.0.5",
	"redux-thunk": "^2.3.0"
};
var dependencies = {
	"arm-common": "1.0.3",
	"arm-gui": "3.0.10",
	"arm-router": "1.0.5",
	"arm-visual-component": "2.1.0",
	"prop-types": "15.7.2"
};
var scripts = {
	beta: "npm version prerelease --preid=beta && gulp npm && npm publish",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish"
};
var publishConfig = {
	registry: "http://nexus.armundia.com:8081/repository/npm-releases/"
};
var pckg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	license: license,
	main: main,
	files: files,
	devDependencies: devDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

var warn = function warn(msg, val) {
  return console.warn("[WizardStore]: " + msg, val);
};
/** 
 * Store of WizardItem to communicate with WizardProcess
*/


var items = {};
/**
 * @typedef {Object} WizardItem properties of WizardItem
 * @property {string} id identifier component
 * @property {string} title label showed in tooltip
 * @property {string} className optional element selector
 * @property {number} number of item
 * @property {boolean} disabled
 * @property {boolean} visible
 * @property {boolean} open
 * @property {Function} openContent to open the content of item
 */

/**
 * 
 * @param {string} id WizardItem id
 * @param {WizardItem} itemProps 
 */

function addItem(id, itemProps) {
  if (items[id]) return warn("item alredy present", items[id]);
  items[id] = itemProps;
}
/**
 * @param {string} id WizardItem id
 */


function getItem(id) {
  if (!items[id]) warn("item with such id is not exist", id);
  return items[id];
}
/**
 * @param {string} id WizardItem id
 */


function deleteItem(id) {
  if (!items[id]) return warn("item with such id is not exist", id);
  delete items[id];
}

var classNamePrefix = "arm-core-layouts-wizard-item";

function WizardFooter(props) {
  console.log('[WizardFooter]: render');
  var id = props.id,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    className: "".concat(classNamePrefix, "-footer ").concat(className).trim()
  }, children);
}

WizardFooter.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

var WizardTitle = function WizardTitle(_ref) {
  var title = _ref.title,
      onOpen = _ref.onOpen,
      number = _ref.number,
      open = _ref.open,
      iconOpen = _ref.iconOpen,
      iconClosed = _ref.iconClosed;
  return !title && !onOpen ? null : /*#__PURE__*/React__default['default'].createElement("div", {
    className: number === 1 ? "".concat(classNamePrefix, "-title ").concat(classNamePrefix, "-title-first") : "".concat(classNamePrefix, "-title")
  }, number && /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix, "-title-circle-sign")
  }, /*#__PURE__*/React__default['default'].createElement("h6", null, number)), /*#__PURE__*/React__default['default'].createElement("h5", null, title), open !== undefined && onOpen && /*#__PURE__*/React__default['default'].createElement("i", {
    className: "".concat(classNamePrefix, "-title-icon ").concat(!open ? iconOpen || "fas fa-plus" : iconClosed || "fas fa-minus"),
    onClick: onOpen
  }));
};

function WizardItem(props) {
  console.log('[WizardItem]: render');
  var id = props.id,
      _props$className2 = props.className,
      className = _props$className2 === void 0 ? '' : _props$className2,
      number = props.number,
      title = props.title,
      children = props.children,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      visible = props.visible,
      open = props.open,
      onOpen = props.onOpen;
  if (visible !== undefined && !visible) return null;
  React.useEffect(function () {
    var propsCopy = _objectSpread2({}, props);

    propsCopy.openContent = function () {
      return onOpen && onOpen(true);
    };

    addItem(id, propsCopy);
    return function () {
      return deleteItem(id);
    };
  }, [open, disabled]);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    id: id,
    className: "".concat(classNamePrefix, " ").concat(className).trim()
  }, /*#__PURE__*/React__default['default'].createElement(WizardTitle, {
    number: number,
    title: title,
    onOpen: onOpen,
    open: open
  }), /*#__PURE__*/React__default['default'].createElement(agui.aCard, {
    className: "".concat(classNamePrefix, "-card ").concat(disabled ? classNamePrefix + '-card-disabled' : '').trim(),
    visible: open
  }, /*#__PURE__*/React__default['default'].createElement(agui.aCardBody, null, children)));
}
WizardItem.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  number: PropTypes.number,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  visible: PropTypes.bool,
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  children: PropTypes.node
};
WizardItem.Footer = WizardFooter;

var idCounter = 0;
var classNamePrefix$1 = 'arm-core-wizard-confirm';

function WizardConfirm(props) {
  console.log('[WizardConfirm]: render');

  var _props$id = props.id,
      id = _props$id === void 0 ? "".concat(classNamePrefix$1, "-").concat(idCounter++) : _props$id,
      className = props.className,
      title = props.title,
      onConfirm = props.onConfirm,
      icon = props.icon,
      children = props.children,
      wizardItemProps = _objectWithoutProperties(props, ["id", "className", "title", "onConfirm", "icon", "children"]);

  var _useState = React.useState(id),
      _useState2 = _slicedToArray(_useState, 1),
      idComp = _useState2[0];

  return /*#__PURE__*/React__default['default'].createElement(WizardItem, _extends({
    id: idComp,
    className: "".concat(classNamePrefix$1, " ").concat(className || '').trim(),
    title: title
  }, wizardItemProps), /*#__PURE__*/React__default['default'].createElement(HBox, {
    className: "".concat(classNamePrefix$1, "-box")
  }, /*#__PURE__*/React__default['default'].createElement(controls.aButton, {
    className: "".concat(classNamePrefix$1, "-btn"),
    bs: "primary",
    inline: true,
    icon: icon,
    onClick: onConfirm
  }, title)));
}

WizardConfirm.propTypes = _objectSpread2({
  id: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
  onConfirm: PropTypes.func,
  icon: PropTypes.string
}, WizardItem.propTypes);

var classNamePrefix$2 = "arm-core-layouts-wizard-process";
var defaultOffset = 0;
/**
 * Javascript helper to scroll and position the window over an element with a id
 * 
 * @param {string} id id of element (without #)
 */

function moveTo(id) {
  scrollToId(id, defaultOffset);
}

function scrollToId(id, yOffset) {
  var _this = this;

  var element = document.querySelector("#" + id);

  if (element) {
    var y = element.getBoundingClientRect().top + window.pageYOffset + (yOffset || defaultOffset);
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  } else {
    setTimeout(function () {
      return _this.scrollToId(id, yOffset);
    }, 100);
  }
}

function WizardProcess(props) {
  console.log('[WizardProcess]: render');
  var currRef = React.useRef(null);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      ticking = _useState2[0],
      setTicking = _useState2[1];

  var _useState3 = React.useState(window.scrollY),
      _useState4 = _slicedToArray(_useState3, 2),
      windowPosition = _useState4[0],
      setWP = _useState4[1];

  var _useState5 = React.useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      prevElemPos = _useState6[0],
      setPrevElemPos = _useState6[1];

  var _useState7 = React.useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      posInDom = _useState8[0],
      setPos = _useState8[1]; //To optimize scroll update


  var onScroll = function onScroll() {
    var lastPosition = window.scrollY;

    if (!ticking) {
      window.requestAnimationFrame(function () {
        setTicking(false);
        setWP(lastPosition);
      });
      setTicking(true);
    }
  };

  React.useEffect(function () {
    window.scrollTo({
      top: 0
    });
    window.addEventListener('scroll', onScroll);

    if (currRef.current) {
      setPrevElemPos(currRef.current.getBoundingClientRect().top);
      defaultOffset = -(currRef.current.getBoundingClientRect().bottom + 1);
      setPos(currRef.current.getBoundingClientRect().bottom + 1);
    }
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, [currRef.current]);
  var elements = props.elements;
  var size = elements === null || elements === void 0 ? void 0 : elements.length;

  if (!elements || size === 0) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    ref: currRef,
    className: classNamePrefix$2,
    style: {
      top: prevElemPos
    }
  }, elements.map(function (elem, index) {
    var elemPosition = 0;
    if (document.querySelector("#" + elem.id)) elemPosition = document.querySelector("#" + elem.id).getBoundingClientRect().top - posInDom + windowPosition;
    var isSelected = Math.floor(windowPosition) >= Math.floor(elemPosition);

    if (index + 1 < size) {
      var nextElem = elements[index + 1];
      var nextElemPosition = 0;
      if (document.querySelector("#" + nextElem.id)) nextElemPosition = document.querySelector("#" + nextElem.id).getBoundingClientRect().top - posInDom + windowPosition;
      isSelected = windowPosition >= elemPosition && windowPosition < nextElemPosition;
    }

    var className = "".concat(classNamePrefix$2, "-circle-sign");
    if (elem.isWC) className = "".concat(classNamePrefix$2, "-wizard-confirm");
    if (isSelected) className += " ".concat(classNamePrefix$2, "-selected");
    return /*#__PURE__*/React__default['default'].createElement("div", {
      "data-balloon-pos": 'down',
      "data-balloon": elem.title || "",
      "data-balloon-break": true,
      key: classNamePrefix$2 + "-" + elem.id,
      className: className,
      onClick: function onClick() {
        var wizardItem = getItem(elem.id);
        wizardItem.openContent();
        setTimeout(function () {
          return scrollToId(elem.id, -posInDom);
        }, 200);
      }
    }, index !== 0 && /*#__PURE__*/React__default['default'].createElement("div", {
      className: isSelected ? "".concat(classNamePrefix$2, "-bar ").concat(classNamePrefix$2, "-selected") : "".concat(classNamePrefix$2, "-bar")
    }), index + 1);
  }));
}

var classNamePrefix$3 = 'arm-core-layouts-wizard';
var idCounter$1 = 0;

function Wizard(props) {
  console.log('[Wizard]: render');
  var _props$id = props.id,
      id = _props$id === void 0 ? "wizard-".concat(idCounter$1++) : _props$id,
      className = props.className,
      children = props.children;

  var _useState = React.useState(id),
      _useState2 = _slicedToArray(_useState, 1),
      idComp = _useState2[0];

  React.useEffect(function () {
    document.getElementsByClassName('arm-core-layouts-applicationcontainer-body')[0].classList.add("".concat(classNamePrefix$3, "-body"));
    return function () {
      return document.getElementsByClassName('arm-core-layouts-applicationcontainer-body')[0].classList.remove("".concat(classNamePrefix$3, "-body"));
    };
  }, []);
  var elements = [];
  var wizardItems = /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].Children.map(children, function (child, index) {
    if (child.type.toString() === Wizard.Item.toString() || child.type.toString() === Wizard.Confirm.toString()) {
      var childProps = _extends({}, child.props);

      childProps.id = childProps.id || "".concat(id, "-item-").concat(index);
      childProps.number = index + 1;
      elements.push({
        id: childProps.id,
        title: childProps.title,
        open: childProps.open,
        isWC: child.type.toString() === Wizard.Confirm.toString()
      });
      return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(child.type, childProps));
    } else {
      console.warn("[Wizard]: accept only WizardItem component", child.type.toString());
    }
  }));
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    id: idComp,
    className: "".concat(classNamePrefix$3, " ").concat(className || '').trim()
  }, /*#__PURE__*/React__default['default'].createElement(WizardProcess, {
    elements: elements
  }), wizardItems), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(classNamePrefix$3, "-background")
  }));
}
Wizard.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
Wizard.Item = WizardItem;
Wizard.Confirm = WizardConfirm;
Wizard.moveTo = moveTo;

var Layouts = {
  version: pckg.version,
  VBox: VBox,
  HBox: HBox,
  ApplicationContainer: ApplicationContainer,
  CollapseContent: CollapseContent,
  MenuLeft: MenuLeft,
  TopBar: TopBar,
  MasterPageContainer: MasterPageContainer,
  PageHeaderContainer: PageHeaderContainer,
  PageContainer: PageContainer,
  PageHeader: PageHeader,
  PageFilter: PageFilter,
  PageFilterGroup: PageFilterGroup,
  PageBody: PageBody,
  PageFooter: PageFooter,
  PageFooterGroup: PageFooterGroup,
  SidePopup: SidePopup,
  Wizard: Wizard
};

exports.ApplicationContainer = ApplicationContainer;
exports.CollapseContent = CollapseContent;
exports.HBox = HBox;
exports.MasterPageContainer = MasterPageContainer;
exports.MenuLeft = MenuLeft;
exports.PageBody = PageBody;
exports.PageContainer = PageContainer;
exports.PageFilter = PageFilter;
exports.PageFilterGroup = PageFilterGroup;
exports.PageFooter = PageFooter;
exports.PageFooterGroup = PageFooterGroup;
exports.PageHeader = PageHeader;
exports.PageHeaderContainer = PageHeaderContainer;
exports.SidePopup = SidePopup;
exports.TopBar = TopBar;
exports.VBox = VBox;
exports.Wizard = Wizard;
exports.default = Layouts;
//# sourceMappingURL=index.js.map
